import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  props: {
    display: null
  },
  setup(__props: any) {



const scrollToTop = () => {
  window.scroll({ top: 0, behavior: "smooth" });
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    class: "scrollToTop text-white",
    icon: "mdi-chevron-up",
    color: "#004191",
    onClick: scrollToTop,
    style: _normalizeStyle({ display: __props.display })
  }, null, 8, ["style"]))
}
}

})